<template>
  <div class="columns is-tabled is-multiline is-centered">
    <div class="column" v-for="item in list" :key="item.name">
      <img
        :src="require(`@/assets/customers/${item.logo}`)"
        :alt="item.name"
        :title="item.name"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
img {
  min-width: 210px;
  display: inline-block;
  margin: 0 auto;
}
</style>

<script>
export default {
  name: "GridPhoto",
  props: {
    list: {
      type: Array,
      default() {
        return [
          {
            name: "Name Demo",
            photo: "https://bulma.io/images/placeholders/1280x960.png"
          }
        ];
      }
    }
  }
};
</script>
